import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/icons/plus_black.png")